import { useAuth } from "@/hooks/use-auth";

/**
 * Returns a stable key for the active actor, or null while it is resolving.
 *
 * The key scopes per-actor localStorage so a previous actor's selections
 * (active project, etc.) don't bleed into the next session. The fork had a
 * second kind of actor — an anonymous guest, keyed by the cookie-backed
 * `guestId` it minted from mcpjam's hosted guest-session route. sphinx has no
 * guest:
 * every actor is a signed-in Yarn user.
 */
export function useActorKey(): string | null {
  const { user, isLoading } = useAuth();
  if (user?.id) return user.id;
  if (isLoading) return null;
  return null;
}
